import PayoutService from '../services/payout';
import { getCurrentLocale } from '../helpers/helper';
import { updateElement } from '../helpers/dom';
import { hasNoTranslationParam, NO_TRANSLATION_QUERY } from '@kano/i18n';

const stylesBlocks = import.meta.glob('/frontend/themes/kano/assets/styles/blocks/*.scss');

document.body.addEventListener('page-content-changed', function (event) {
  const { withPaybisYouCanAlso, metaTitle } = event.detail;

  const youCanAlsoBlock = document.getElementById('with-paybis-you-can-also');
  if (youCanAlsoBlock) {
    youCanAlsoBlock.innerHTML = withPaybisYouCanAlso;
  }

  document.title = metaTitle
});

export const updateContent = (relationLink, currency) => {
  const language = getCurrentLocale();
  const queryParams = {
    link: relationLink,
    language: language,
    currency: currency,
    kano: true,
  }

  if(hasNoTranslationParam()) {
    queryParams[NO_TRANSLATION_QUERY] = true;
  }

  return PayoutService.getDescription(queryParams)
    .then(async (data) => {
      const pageContentChangeEvent = new CustomEvent('page-content-changed', {
        detail: data,
      });

      const {
        howItWorks,
        quickGuide,
        faq,
        features,
        fcaNotificationFooter,
        whatCanYouDo,
        unlockPower,
        breadcrumbs,
        learn,
        cryptoMarketNews,
        whatIs,
        otherCryptos,
        cryptoTrends,
        navigation,
        usdtNotice,
      } = data;

      const usdtNoticeBlock = document.getElementById('usdt-notice');
      if (usdtNoticeBlock) {
        usdtNoticeBlock.innerHTML = usdtNotice ?? '';
      }

      if (navigation && navigation.trim()) {
        const navigationBlock = document.querySelector('.navigation');
        if (navigationBlock) {
          navigationBlock.outerHTML = navigation;
        }
      }

      updateElement(document.querySelector('#how-to'), {
        newContent: howItWorks,
        cssImport: stylesBlocks['/frontend/themes/kano/assets/styles/blocks/how-to.scss'],
      });

      updateElement(document.querySelector('#breadcrumbs'), {
        newContent: breadcrumbs,
        cssImport: stylesBlocks['/frontend/themes/kano/assets/styles/blocks/breadcrumbs.scss'],
      });

      updateElement(document.querySelector('#quick-guide'), { newContent: quickGuide });
      updateElement(document.querySelector('#learn'), { newContent: learn });
      updateElement(document.querySelector('#what-can-you-do'), { newContent: whatCanYouDo });
      updateElement(document.querySelector('#unlock-power'), { newContent: unlockPower });
      updateElement(document.querySelector('#popular-faq'), { newContent: faq });
      updateElement(document.querySelector('#features'), { newContent: features });
      updateElement(document.querySelector('#crypto-trends'), { newContent: cryptoTrends });

      const otherCryptosBlock = document.querySelector('#other-cryptos');
      if (otherCryptosBlock && otherCryptos && otherCryptos.trim()) {
        const { mountOtherCryptocurrenciesListApp } = await import('@kano/other-cryptocurrencies-list');
        otherCryptosBlock.innerHTML = otherCryptos;

        mountOtherCryptocurrenciesListApp();
      }

      const fcaNotificationFooterBlock = document.querySelector('#fca-notification-footer');
      if (fcaNotificationFooterBlock) {
        fcaNotificationFooterBlock.innerHTML = fcaNotificationFooter;
      }

      const priceBlock = document.querySelector('#price');
      if (priceBlock && cryptoMarketNews && cryptoMarketNews.trim()) {
        const { mountPriceChartApp } = await import('@kano/crypto-price-chart');
        const { mountCryptoSentimentTooltip } = await import('@kano/crypto-sentiment-tooltip');

        priceBlock.innerHTML = cryptoMarketNews;
        mountCryptoSentimentTooltip();
        mountPriceChartApp();
      }

      updateElement(document.querySelector('#what-is'), { newContent: whatIs });

      document.body.dispatchEvent(pageContentChangeEvent);
  });
};
